import { Injectable } from '@angular/core';
import {Idiomas} from "../dominio/idiomas/idiomas";
import {ApiService} from "./api.service";
import {Response} from "../dominio/Response";
import {ToastrService} from "ngx-toastr";
import {Router} from "@angular/router";
import {Subject} from "rxjs/Subject";
import {StaticLenguage} from "../dominio/staticLenguage";
import {Observable} from "rxjs/Observable";
import {RestService} from "../../usuarios/services/rest.service";
import {IdiomasMenu} from "../dominio/idiomas/idiomasMenu";

@Injectable()
export class LenguageService {
  lenguages: Array<IdiomasMenu>;
  // variable del sistema, con el que se realizan las consultas a la bd de cada idioma
  // Observado
  private lang = new Subject<string>();
  private idiomas = new Subject<Idiomas[]>();
  // Observador
  public lang$ = this.lang.asObservable();
  public idiomas$ = this.idiomas.asObservable();
  constructor(private apiService: ApiService, private toastr: ToastrService, private router: Router) {
    this.lenguages = new Array<IdiomasMenu>();
      const lang = this.urlToLang();
      this.setLenguages();
  }
  //  Get listado de idiomas
  public getLenguages() {
    return this.lenguages;
  }
  public getIdiomas() {
      this.apiService.get('idiomas')
          .subscribe(  (response: Response) => {
              this.idiomas.next(response.data);
          });
  }
  /*public getLenguagesUser() {
      let lenguages = new Array<IdiomasMenu>();
      this.apiService.get('idiomas')
          .subscribe(  (response: Response) => {
              response.data.map(
                  (item, index) => {
                      if (index === 0) {
                          const first = new IdiomasMenu(item.cod, item.nombre);
                          first.visible = true;
                          lenguages.push(first);
                          this.setLang(first.cod);
                      } else {
                          lenguages.push(new IdiomasMenu(item.cod, item.nombre));
                      }
                      this.lenguagesUser.next(lenguages);
                  });
          }, error => {
              this.toastr.warning(error.error.data, 'Error');
          });
  }*/
  // Setear lista de idiomas disponibles en el sistema
  private setLenguages() {
      this.apiService.get('idiomas')
          .subscribe(  (response: Response) => {
              response.data.map(
                  (item, index) => {
                      if (index === 0) {
                          const first = new IdiomasMenu(item.cod, item.nombre);
                          first.visible = true;
                          this.lenguages.push(first);
                          this.setLang(first.cod);
                      } else {
                          this.lenguages.push(new IdiomasMenu(item.cod, item.nombre));
                      }
              });
          }, error => {
              this.toastr.warning(error.error.data, 'Error');
          });
  }
  // Setear codigo identificador de idioma
  public setLang(code) {
    this.lang.next(code);
    this.lang$.subscribe(
        _lang => {
            this.apiService.lang = _lang;
        });
  }
  public urlWithLenguage() {
      const url = this.getUrl();
      return (url === '/') ? false : true;
  }
  // Al entrar por primera vez a una url o actualizar la pagina analiza que idioma tiene la url para setear lang
  public urlToLang() {
      let url = this.getUrl();
      if (this.isLongRoute(url)) {
          url = this.firstRoute(url);
      } else {
          url = this.getUrl();
      }
      const code = url.replace('/', '');
      this.setLang(code);
      return code;
  }

  // tomo el codigo del nuevo idioma, lo seteo y genero la url en ese idioma.
  public langToUrl(code) {
    let url = this.getUrl();
    this.setLang(code);
      if (this.isLongRoute(url)) {
          url = this.restRoute(url);
      } else {
          url = '';
      }
       url = '/' + code + url;
      this.router.navigate([url]);
  }
  /* functions routes and url*/
    getUrl() {
        return this.router.url;
    }
    isLongRoute(url) {
        const regex = new RegExp('^(\\/)\\w+(\\/)');
        return regex.test(url);
    }
    firstRoute(url) {
        const beggin = 0;
        const end = url.indexOf('/', 1);
        return url.substring(beggin, end);
    }
    restRoute(url) {
        // obtengo el resto de url sin el idioma
        return url.slice((url.indexOf('/', 1) - url.length));
    }
	//Boolean, Verifica si la url contiene "admin/crearInvestigador" o "admin/modificarInvestigador"
	public adminEditando(){
		let url = this.getUrl();
		//si indexOf devuelve -1 quiere decir que no encontró el texto en url
		return url.indexOf('admin/crearInvestigador') !== -1 || url.indexOf('admin/modificarInvestigador') !== -1;
	}

}



// WEBPACK FOOTER //
// ./src/app/shared/services/lenguage.service.ts